import ShipIcon from './ShipIcon'

export default ShipIcon
